import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import styles from '../Login/Login.module.css';
import { useAuth } from '../Context/Auth';
import { Link, useNavigate } from 'react-router-dom';
import carLogo from '../Image/logocar-CN7UAsq-.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { loginUser, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const loginPromise = loginUser({ email, password });

    toast.promise(
      loginPromise,
      {
        loading: 'Logging in...',
        success: 'Welcome back! 🚗',
        error: 'Email or Password is incorrect 😢',
      }
    );

    const result = await loginPromise;

    if (result && result.Success) {
      // حفظ التوكن واسم المستخدم
      localStorage.setItem('userToken', result.Data?.AccessToken || '');
      localStorage.setItem('userEmail', email);

      // تأخير 1 ثانية قبل الانتقال
      setTimeout(() => {
        navigate('/');
      }, 1000);
    }
  };

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  return (
    <div className={styles.loginContainer}>
      <Toaster position="top-center" reverseOrder={false} />

      <Link to="/" className={styles.backButton}>
        ← Back to Home
      </Link>

      <div className={styles.loginBox}>
        <div className={styles.logoContainer}>
          <img src={carLogo} alt="KARZONE Logo" className={styles.logo} />
          <h1 className={styles.brandName}>KARZONE</h1>
          <h2 className={styles.tagline}>PremiumDrive</h2>
          <p className={styles.subTagline}>LUXURY MOBILITY EXPERIENCE</p>
        </div>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div className={styles.formGroup}>
            <input
              type="email"
              className={styles.inputField}
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={`${styles.formGroup} ${styles.passwordField}`}>
            <input
              type={showPassword ? 'text' : 'password'}
              className={styles.inputField}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className={styles.eyeIcon}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </span>
          </div>

          <button
            type="submit"
            className={styles.loginButton}
            disabled={loading}
          >
            {loading ? 'ACCESSING...' : 'ACCESS PREMIUM GARAGE'}
          </button>

          {error && <p style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>{error}</p>}
        </form>

        <p className={styles.accountText}>Don't have an account?</p>
        <Link to="/register" className={styles.createAccountLink}>
          CREATE ACCOUNT
        </Link>
      </div>
    </div>
  );
};

export default Login;
